const state = () => ({
  isModalOpened: false,
});

const getters = {
  getIsModalOpened: (state) => {
    return state.isModalOpened;
  },
};

const mutations = {
  setIsModalOpened: (state, payload) => {
    state.isModalOpened = payload;
  },
};

const actions = {
  updateIsModalOpened({ commit }, payload) {
    commit('setIsModalOpened', payload);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
